<template>
  <div class="page-container">
    <headerSection></headerSection>

    <!-- Hero Section -->
    <div class="hero-section">
      <div class="floating-ball ball-1"></div>
      <div class="floating-ball ball-2"></div>
      <div class="floating-ball ball-3"></div>

      <div class="container">
        <div class="hero-content">
          <div class="hero-icon-wrapper">
            <span class="hero-icon">💎</span>
          </div>
          <h1 class="title-glow">{{ $t('cashback_page.title') }}</h1>
          <p class="hero-description">คืนยอดเสียทุกวัน</p>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="container main-content">
      <!-- Banner -->
      <div class="banner-section">
        <img src="../assets/images/time2lucky-introduction.png" class="banner-image" alt="Cashback Banner">
      </div>

      <!-- Stats Title -->
      <div class="stats-title">{{ $t('cashback_page.title2') }}</div>

      <!-- 3 Stats Cards -->
      <div class="cashback-stats">
        <div class="stat-card">
          <div class="stat-icon">📥</div>
          <div class="stat-label">{{ $t('deposit') }}</div>
          <div class="stat-value">{{ numberWithCommas(this.cashback.deposit) }}</div>
        </div>

        <div class="stat-card">
          <div class="stat-icon">📤</div>
          <div class="stat-label">{{ $t('withdraw') }}</div>
          <div class="stat-value">{{ numberWithCommas(this.cashback.withdraw) }}</div>
        </div>

        <div class="stat-card stat-card-wide">
          <div class="stat-icon">💰</div>
          <div class="stat-label">{{ $t('partner_title6') }}</div>
          <div class="stat-value stat-value-large">{{ numberWithCommas(this.cashback.total) }}</div>
        </div>
      </div>

      <!-- Claim Button -->
      <div class="claim-section">
        <button @click="moveCashbackToWallet()"
                :class="['claim-btn', { 'disabled': !(cashback && cashback.total > 0) }]"
                :disabled="!(cashback && cashback.total > 0) || disabled">
          {{ $t('partner_title7') }}
        </button>
      </div>

      <!-- Details Section -->
      <div class="details-card" v-if="detail">
        <div class="details-text" v-html="nl2br(detail)"></div>
      </div>
    </div>

    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import moment from 'moment-timezone'
import router from './../router'
const axios = require('axios').default
export default {
  name: 'Cashback',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  data: function () {
    return {
      cashback: [],
      detail: '',
      disabled: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    }
  },
  methods: {
    async waitForCashbackClaimResult (key, attempts = 10) {
      for (let attempt = 0; attempt < attempts; attempt++) {
        const snapshot = await firebase.firestore().collection('cashback').doc(key).get()
        const data = snapshot.exists ? (snapshot.data() || {}) : {}

        if (data.status === true) {
          return { status: true, total: Number(data.total || 0) }
        }

        if (data.blocked_reason || data.error) {
          return {
            status: false,
            code: data.blocked_reason || 'CASHBACK_CLAIM_BLOCKED',
            error: data.error || 'ไม่สามารถรับคืนยอดเสียได้ในขณะนี้'
          }
        }

        await new Promise(resolve => setTimeout(resolve, 500))
      }

      return {
        status: false,
        code: 'CASHBACK_CLAIM_TIMEOUT',
        error: 'ระบบกำลังตรวจสอบรายการ กรุณารอสักครู่แล้วลองใหม่อีกครั้ง'
      }
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    async moveCashbackToWallet () {
      if (this.cashback.total && this.cashback.key && !this.disabled) {
        this.disabled = true
        this.$store.commit('user/SET_LOADING', true)
        try {
          const claim = await axios.get(`https://time2lucky.apifast.xyz/qcashback/cashback/${this.cashback.key}`)
          let result = claim && claim.data ? claim.data : {}
          if (result.status === undefined && result.id) {
            result = await this.waitForCashbackClaimResult(this.cashback.key)
          }
          if (!result.status) {
            this.$swal({
              icon: 'error',
              title: 'ไม่สามารถรับคืนยอดเสียได้',
              text: result.error || 'กรุณาลองใหม่อีกครั้ง'
            })
            return
          }

          await this.getCashBack()
          this.$swal({
            icon: 'success',
            title: 'รับคืนยอดเสียสำเร็จ',
            text: `เพิ่มเครดิต ${Number(result.total || 0).toLocaleString()} บาทแล้วค่ะ`
          })
        } catch (error) {
          const message = error && error.response && error.response.data && error.response.data.error
          this.$swal({
            icon: 'error',
            title: 'ไม่สามารถรับคืนยอดเสียได้',
            text: message || 'กรุณาลองใหม่อีกครั้ง'
          })
        } finally {
          this.$store.commit('user/SET_LOADING', false)
          this.disabled = false
        }
      }
    },
    numberWithCommas (x) {
	  if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
     nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return '';
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },
    async getCashBack () {
      this.detail = (await firebase.database().ref(`/cashback/detail`).once('value')).val();
      const user = this.getUserId()
      if (user) {
        return firebase.firestore().collection('cashback').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) this.cashback = []
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.cashback = data
          })
        })
      }
    }
  },
  mounted () {
    this.scrollToTop()
    this.getCashBack()
  }
}
</script>

<style scoped>
/* Page Container */
.page-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #09030f 0%, #220735 50%, #09030f 100%);
  padding-bottom: 100px;
  font-family: 'Kanit', sans-serif;
}

/* Hero Section */
.hero-section {
  position: relative;
  padding: 80px 0 30px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(112, 32, 170, 0.1) 0%, transparent 100%);
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-icon-wrapper {
  display: inline-block;
  margin-bottom: 20px;
  animation: bounce 2s ease-in-out infinite;
}

.hero-icon {
  font-size: 64px;
  display: block;
  filter: drop-shadow(0 4px 15px rgba(183, 90, 255, 0.4));
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.title-glow {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  text-shadow:
    0 0 20px rgba(183, 90, 255, 0.5),
    0 0 40px rgba(112, 32, 170, 0.3),
    0 2px 4px rgba(0, 0, 0, 0.5);
}

.hero-description {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
}

/* Floating Balls */
.floating-ball {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  pointer-events: none;
  z-index: 1;
}

.floating-ball.ball-1 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #7020aa, #e0b5ff);
  top: -50px;
  left: -100px;
  animation: float1 6s ease-in-out infinite;
}

.floating-ball.ball-2 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #e0b5ff, #7020aa);
  top: 50%;
  right: -75px;
  animation: float2 8s ease-in-out infinite;
}

.floating-ball.ball-3 {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #220735, #7020aa);
  bottom: 20%;
  left: 10%;
  animation: float3 7s ease-in-out infinite;
}

@keyframes float1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(30px, 20px) rotate(180deg); }
}

@keyframes float2 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(-20px, 30px) rotate(-180deg); }
}

@keyframes float3 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(20px, -20px) rotate(180deg); }
}

/* Main Content */
.main-content {
  padding: 0 20px;
  margin-top: 20px;
}

/* Banner Section */
.banner-section {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(112, 32, 170, 0.2);
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.banner-image {
  width: 100%;
  height: auto;
  display: block;
}

/* Stats Title */
.stats-title {
  background: rgba(112, 32, 170, 0.1);
  padding: 12px 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  text-align: center;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
}

/* Cashback Stats */
.cashback-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(112, 32, 170, 0.2);
  border-radius: 12px;
  padding: 25px;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.stat-card:hover {
  transform: translateY(-5px);
  border-color: rgba(183, 90, 255, 0.4);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
}

.stat-card-wide {
  grid-column: 1 / -1;
}

.stat-icon {
  font-size: 48px;
  margin-bottom: 15px;
  filter: drop-shadow(0 0 10px rgba(183, 90, 255, 0.3));
}

.stat-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 10px;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #e0b5ff;
  text-shadow: 0 0 15px rgba(183, 90, 255, 0.4);
}

.stat-value-large {
  font-size: 36px;
  text-shadow: 0 0 20px rgba(183, 90, 255, 0.5);
}

/* Claim Section */
.claim-section {
  text-align: center;
  margin-bottom: 30px;
}

.claim-btn {
  background: linear-gradient(135deg, #7020aa, #32074d);
  border: none;
  border-radius: 8px;
  padding: 15px 40px;
  color: #fff1d3;
  font-weight: 600;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow:
    0 4px 15px rgba(183, 90, 255, 0.4),
    0 0 20px rgba(183, 90, 255, 0.3);
  font-family: 'Kanit', sans-serif;
}

.claim-btn:hover:not(.disabled) {
  transform: translateY(-2px);
  box-shadow:
    0 6px 25px rgba(183, 90, 255, 0.5),
    0 0 30px rgba(183, 90, 255, 0.4);
  filter: brightness(1.1);
}

.claim-btn.disabled {
  background: linear-gradient(135deg, #666, #444);
  color: #999;
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.6;
}

/* Details Card */
.details-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(112, 32, 170, 0.2);
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.details-text {
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.8;
  font-size: 16px;
  text-align: center;
}

/* Responsive Design */
@media screen and (max-width: 768px) {
  .hero-section {
    padding: 75px 0 25px;
  }

  .title-glow {
    font-size: 28px;
  }

  .hero-icon {
    font-size: 48px;
  }

  .floating-ball.ball-1 {
    width: 150px;
    height: 150px;
  }

  .floating-ball.ball-2 {
    width: 100px;
    height: 100px;
  }

  .floating-ball.ball-3 {
    width: 80px;
    height: 80px;
  }

  .cashback-stats {
    grid-template-columns: 1fr;
  }

  .stat-card-wide {
    grid-column: 1;
  }
}

@media screen and (max-width: 480px) {
  .hero-section {
    padding: 70px 0 20px;
  }

  .title-glow {
    font-size: 24px;
  }

  .hero-description {
    font-size: 14px;
  }

  .hero-icon {
    font-size: 40px;
  }

  .stat-card {
    padding: 20px 15px;
  }

  .stat-icon {
    font-size: 40px;
  }

  .stat-value {
    font-size: 24px;
  }

  .stat-value-large {
    font-size: 28px;
  }

  .claim-btn {
    padding: 12px 30px;
    font-size: 16px;
  }
}
</style>
